import { z } from "zod";

export const bookActivitySchema = () => {
  return z.object({
    name: z.string().min(1),
    type: z.string().optional().nullable(),
    sector: z.any().optional().nullable(),
    categories: z.array(z.number()).min(1),
    image: z.any().optional().nullable(),
  });
};

export type BookActivityFormValues = z.infer<ReturnType<typeof bookActivitySchema>>;
